export default __webpack_public_path__ + "media/images/amenities/cleaning_tools-bcb9a9d6c347592676dbf30e78a1e5ad.jpeg";